import {apiFetch} from '../api/fetch'
import {
    type JobCommentCreateInput,
    jobCommentCreateInputSchema,
    jobCommentRawSchema,
    type JobCommentUpdateInput,
    jobCommentUpdateInputSchema,
} from './schemas'

export async function createJobComment(
    jobId: string,
    input: JobCommentCreateInput,
): Promise<ReturnType<typeof jobCommentRawSchema.parse>> {
    const body = jobCommentCreateInputSchema.parse(input)
    const response = await apiFetch(`/jobs/${jobId}/notes`, {
        method: 'POST',
        body: JSON.stringify(body),
    })
    return jobCommentRawSchema.parse(response)
}

export async function updateJobComment(
    jobId: string,
    commentId: string,
    input: JobCommentUpdateInput,
): Promise<ReturnType<typeof jobCommentRawSchema.parse>> {
    const body = jobCommentUpdateInputSchema.parse(input)
    const response = await apiFetch(`/jobs/${jobId}/notes/${commentId}`, {
        method: 'PUT',
        body: JSON.stringify(body),
    })
    return jobCommentRawSchema.parse(response)
}

export async function deleteJobComment(jobId: string, commentId: string): Promise<void> {
    await apiFetch(`/jobs/${jobId}/notes/${commentId}`, {
        method: 'DELETE',
    })
}
